export default __webpack_public_path__ + "static/media/allourdonut.01b19d2b.png";